import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export function downloadAuthorizedAgentDesignationForm() {
    return http.get(API_PATHS.getAuthorizedAgentDesignationForm, { responseType: 'blob', params: {} });
};